import React from "react";
import { Box, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { ShiftTypes } from "../../utils/constants";

interface IStaffDuties {
  StaffDuties: any;
}

export const DashboardWeekSchedule = ({ StaffDuties = [] }: IStaffDuties) => {


  const weekSchedule: any[] = [
    { day: "Sunday", bgColor: "#E9F1FF", borderColor: "#3C98CC" },
    { day: "Monday", bgColor: "#F0FBF7", borderColor: "#00BB8C" },
    { day: "Tuesday", bgColor: "#FBFBF1", borderColor: "#C9CC3C" },
    { day: "Wednesday", bgColor: "#E9F1FF", borderColor: "#3C98CC" },
    { day: "Thursday", bgColor: "#F0FBF7", borderColor: "#00BB8C" },
    { day: "Friday", bgColor: "#FBFBF1", borderColor: "#C9CC3C" },
    { day: "Saturday", bgColor: "#E9F1FF", borderColor: "#3C98CC" },
  ];


  weekSchedule.forEach((day: any) => {
    const isOffDay = StaffDuties[0]?.off_day?.includes(day?.day);

    if (isOffDay) {
      day.bgColor = "#FFCCCC";
      day.borderColor = "#FF0000";
      day.start_time = null;
      day.end_time = null;
      day.shift_type = null;
      day.workingHours = null;
    } else {
      // Add shift details for working days
      day.start_time = StaffDuties[0]?.start_time || "-";
      day.end_time = StaffDuties[0]?.end_time || "-";
      day.shift_type = StaffDuties[0]?.shift_type || "-";
      day.workingHours = StaffDuties[0]?.pharmacyStaff?.workingHours || 0; 
      // Calculate hours difference for working days
    }
  });

 

  return (
    <Box
      sx={{
        display: "flex",
        width: "90%",
        justifyContent: "center",
        alignItems: "center",
        px: 0,
        pt: 2,
        mx: "auto",
        flexDirection: "row",
      }}
    >
      {weekSchedule?.map(
        ({
          day,
          bgColor,
          borderColor,
          start_time,
          end_time,
          shift_type,
          workingHours,
        }) => (
          <Box
            key={day}
            sx={{
              width: "80%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              mx: 0,
            }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "400",
                color: "#2C323D",
                marginBottom: "5px",
              }}
            >
              {day}
            </Typography>
            <Box
              sx={{
                width: "100%",
                height: "117px",
                display: "flex",
                flexDirection: "column",
                backgroundColor: bgColor,
                boxShadow: "0px 2px 8px 0px #11319F8C",
                borderRadius: "8px",
                borderLeft: `4px solid ${borderColor}`,
              }}
            >
              <Typography
                sx={{
                  fontWeight: "500",
                  textAlign: "center",
                  marginTop: "25px",
                  fontSize: { xs: "12px",lg: "14px" },
                  lineHeight: "21px",
                  color: "#171717",
                  padding: "0 5px",
                }}
              >
                {start_time === null
                  ? "OFF DAY"
                  : `${start_time} - ${end_time}`}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "2px",
                  margin: "2px 0",
                }}
              >
                {start_time === null ? (
                  ""
                ) : (
                  <AccessTimeIcon sx={{ color: "#979797", height: "16px" }} />
                )}
                <Typography
                  sx={{
                    fontWeight: "500",
                    fontSize: "12px",
                    lineHeight: "18px",
                    color: "#979797",
                  }}
                >
                  {workingHours === null
                    ? ""
                    : `${workingHours?.toFixed(1)} Hrs`}
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontWeight: "500",
                  textAlign: "center",
                  fontSize: "12px",
                  lineHeight: "18px",
                  color: "#979797",
                }}
              >
                {shift_type === ShiftTypes.MORNING
                  ? "Morning Shift"
                  : shift_type === ShiftTypes.EVENING
                    ? "Evening Shift"
                    : shift_type === ShiftTypes.NIGHT
                      ? "Night Shift"
                      : ""}
              </Typography>
            </Box>
          </Box>
        )
      )}
    </Box>
  );
};
